// extracted by css-extract-rspack-plugin
var _1 = "qGjCcWpSUNQMdjqB";
var _2 = "grDW5UANNdg6LkRh";
var _3 = "B2htkrA91RIR5T1l";
export { _1 as "list", _2 as "title", _3 as "wrapper" }
